var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "base-input base-input--currency" },
    [
      _vm.label
        ? _c("label", { attrs: { for: _vm.id } }, [
            _vm._v("\n\t\t" + _vm._s(_vm.label) + "\n\t")
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("input", {
        ref: "currencyInput",
        attrs: {
          type: "tel",
          id: _vm.id,
          name: _vm.name,
          required: _vm.isRequired,
          placeholder: _vm.label ? "" : _vm.placeholder
        },
        domProps: { value: _vm.modelValue },
        on: {
          keydown: _vm.handleKeydown,
          input: _vm.handleInput,
          focus: _vm.handleFocus,
          blur: _vm.formatInput
        }
      }),
      _vm._v(" "),
      _vm._t("icon")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }